import React from "react";

const cities = [
  { name: "New York", value: 72 },
  { name: "San Francisco", value: 39 },
  { name: "Sydney", value: 25 },
  { name: "Singapore", value: 61 },
];

export default function CityStats() {
  return (
    <div className="w-full max-w-xs p-2 rounded-lg font-inter">
      {cities.map((city, index) => (
        <div key={index} className="mb-3 last:mb-0">
          <div className="flex justify-between items-center mb-1">
            <span className="text-sm">{city.name}</span>
            <span className="text-sm">{city.value}K</span>
          </div>
          <div className="w-full h-[3px] bg-[#e6eef5] rounded-full overflow-hidden">
            <div
              className="h-full bg-[#a8c5da] rounded-full"
              style={{ width: `${city.value}%` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
}
